module.exports = __webpack_public_path__ + "static/media/ref2.8f84268a.jpg";